$(document).ready(function() {
  $('#form-consulenza').on('submit', function(e){
    e.preventDefault();

    var nome = $('input[name="fldName"]').val();
    var cognome = $('input[name="fldSurname"]').val();
    var dataNascita = $('input[name="fldDate"]').val();
    var telefono = $('input[name="fldTel"]').val();
    var email = $('input[name="fldEmail"]').val();
    var pelle = $('input[name="fldPelle"]:checked').val();
    var problemiPelle = [];
    $('input[name="fldProblemiPelle"]:checked').each(function() {
      problemiPelle.push($(this).val());
    });
    var descrizioneProblema = $('textarea[name="fldTextarea"]').val();

    var datiForm = {
      nome: nome,
      cognome: cognome,
      dataNascita: dataNascita,
      telefono: telefono,
      email: email,
      pelle: pelle,
      problemiPelle: problemiPelle,
      descrizioneProblema: descrizioneProblema
    };

    $.ajax({
      url: 'https://mediterranea-site.nohup.host/api/cosmetic-consultation',
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(datiForm),
      success: function(response, status, xhr) {
        if (xhr.status === 200) {
          $('.consulenza-form-content .confirm-message').addClass('show');
          $('.consulenza-form-content .confirm-message p').text("Form inviato con successo");
        } else {
          alert('Si è verificato un errore: ' + xhr.statusText);
        }
      },
      error: function(xhr, status, error) {
        console.error('Errore durante l\'invio:', error);
        alert('Si è verificato un errore, riprova.');
      }
    });

  });
})                